import { useEffect, useRef } from 'react'

import { useAppConfigStore } from '@/stores/app-store-config/appConfigStore'
import { useCartStore } from '@/stores/cart-store/cartStore'
import { CartRoom } from '@/stores/cart-store/slices/types'
import { useStepStore } from '@/stores/step-store/stepStore'

export const useRoomSelectionQuery = () => {
	const urlQuery = useAppConfigStore.use.urlQuery()
	const setUrlQuery = useAppConfigStore.use.setUrlQuery()
	const setNextStep = useStepStore.use.setNextStep()
	const roomConfigurations = useCartStore.use.roomConfigurations()
	const setReservationId = useCartStore.use.setReservationId()
	const setRoom = useCartStore.use.setRoom()

	const hasRun = useRef(false)

	useEffect(() => {
		if (hasRun.current) return
		if (!urlQuery) return

		const { rooms, ...restQuery } = urlQuery

		if (rooms && rooms?.length >= 1) {
			roomConfigurations.forEach((config, index) => {
				const roomToConfig = rooms[index]
				if (!roomToConfig) return

				setRoom({
					roomConfigId: config.id,
					room: roomToConfig as CartRoom,
				})
			})

			if (roomConfigurations.length === rooms.length && urlQuery.reservationId) {
				setReservationId(urlQuery.reservationId)
				setNextStep()
			}
		}

		hasRun.current = true
		setUrlQuery(restQuery)
	}, [urlQuery, setUrlQuery, roomConfigurations, setRoom, setReservationId, setNextStep])
}
